export default __webpack_public_path__ + "static/media/fish-lqMIN.jpg.4f6ce4ff.txt";